import React from 'react'
import styled from 'styled-components'
import {
  Alert,
} from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import colors from 'constants/colors'

const Bar = styled(Alert)`
  background-color: #FDF0D2;
  border-radius: 14px;
  padding: 11px 13px;
  margin-bottom: 35px;
  border: 1px solid #FFDF97;
`

const Title = styled.h4`
  font-family: Poppins;
  font-size: 16px;
  color: ${colors.black};
  letter-spacing: 0;
  font-weight: 600;
  margin-bottom: 3px;
`

const Text = styled.p`
  font-family: Poppins;
  font-weight: 400;
  font-size: 12px;
  color: #242735;
  letter-spacing: 0;
  display: inline-block;
  margin-bottom: 0;
`

const TextHighlighted = styled.p`
  font-family: Poppins;
  font-weight: 600;
  font-size: 12px;
  color: #B88005;
  letter-spacing: 0;
  display: inline-block;
  margin-right: 5px;
  margin-bottom: 0;
  background-color: #FFCE62;
  border-radius: 10px;
  text-align: center;
  width: 18px;
  height: 17px;
`

const Item = styled.div`
  display: inline-block;
  padding-right: 8px;
`

type BarProps = {
  items?: {label: string, index: string}[],
  title?: string,
}

const OnboardingBar = ({
  items,
  title,
}: BarProps) => {
  return (
    <Bar>
      <Title>
        <FontAwesomeIcon
          icon="graduation-cap"
          className="mr-2"
          color={colors.black}
        />
        {title}
      </Title>
      {items?.map((item) => {
        return (
          <Item>
            <TextHighlighted>{item.index}</TextHighlighted>
            <Text>{item.label}</Text>
          </Item>
        )
      })}
    </Bar>
  )
}

export default OnboardingBar
